import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { NzTypographyComponent } from 'ng-zorro-antd/typography';
import { RouterLink } from '@angular/router';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { MetaService } from '../../service/meta.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-privacy-policy-page',
  imports: [
    NzColDirective,
    NzRowDirective,
    NzTypographyComponent,
    RouterLink,
    NzDividerComponent,
  ],
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.less',
})
export class PrivacyPolicyPageComponent implements OnInit {
  private static readonly URI: 'privacy-policy' = 'privacy-policy' as const;
  private readonly metaService: MetaService = inject(MetaService);

  public ngOnInit(): void {
    this.metaService.setTitle(
      $localize`:@@page-privacy-policy-title:Privacy policy: Ig4u`
    );
    this.metaService.setDescription(
      $localize`:@@page-privacy-policy-description:Detailed privacy policy for the Ig4u service. Description of administrator and user rights`
    );
    this.metaService.setKeywords(
      $localize`:@@page-privacy-policy-keywords:privacy policy, administrator and user rights, ig4u`
    );
    this.metaService.setCanonical(PrivacyPolicyPageComponent.URI);
    this.metaService.setAlternatives(PrivacyPolicyPageComponent.URI);
    this.metaService.disableIndexing();
  }
}
